import React, { useState } from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { styled } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import { InputLabel } from '@mui/material';

export const Monto = ({dn, montos, getMonto}) => {

    const [monto, setMonto] = useState('');

    

      const handleChange = (event) => {
        setMonto(event.target.value);
        getMonto(event.target.value);
      };

      const BootstrapInput = styled(InputBase)(({ theme }) => ({
        'label + &': {
          marginTop: theme.spacing(3),
        },
        '& .MuiInputBase-input': {
          borderRadius: 4,
          position: 'relative',
          backgroundColor: theme.palette.background.paper,
          border: '1px solid #ced4da',
          fontSize: 22,
          padding: '10px 26px 10px 12px',
     
          transition: theme.transitions.create(['border-color', 'box-shadow']),
          // Use the system font instead of the default Roboto font.
          fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
          ].join(','),
          '&:focus': {
            borderRadius: 4,
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
          },
        },
      }));
  


  return (



    <div className='contienecel'>
                <div className='tituloInput '>Número a recargar:</div>
                <div className='dnEstilo animate__animated '>{dn}</div>
                  <div className='tituloInput '>Selecciona el monto a recargar:</div>
                  <div className='contenedorMontos animate__animated '>
                      <FormControl className="chosMo">
                         
                          <Select
                              labelId="demo-simple-select-required-label"
                              id="demo-simple-select-required"
                              value={monto}
                              label="Elige un monto"
                              onChange={handleChange}
                              input={<BootstrapInput />}
                          >
                              {
                                montos.map( (monto, i) => (
                                  <MenuItem key={ monto.value } value={monto.value}>${monto.value}</MenuItem>
                                    
                                    )
                                )
                            }        
                              
                          </Select>
                      </FormControl>
                  </div>
                  
   </div>
  )
}
